// "Influencer, Celebrity" or "Chef & Host" -> each profession on its own
export const splitProfessions = (t) => (t || "").split(/\s*(?:,|;|\/|&|\band\b|\+)\s*/i).map((x) => x.trim()).filter(Boolean);
